import { data } from "autoprefixer";
import axios from "../api";
//获取展品,列表
const exhibition_list = (data) =>
	axios(
		"exhibit/exhibit_list", {
		p: PLAT,
		museum_id: MID,
		page: data.page,
		limit: data.limit,
		exhibition_id: data.exhibition_id
	},
		"GET", {
		isLoading: true,
		loadingText: '加载中...'
	}
	);
//获取基本陈列或临展列表
const exhibits_list = (data) =>
	axios(
		"/exhibition/exhibition_list", {
		p: PLAT,
		museum_id: MID,
		page: data.page,
		limit: data.limit,
		type: data.type//类型1基本陈列2临展
	},
		"GET", {
		isLoading: true,
		loadingText: '加载中...'
	}
	);
//展览详情接口
const exhibits_info = (exhibition_id) =>
	axios(
		"/exhibition/exhibition_info", {
		p: PLAT,
		exhibition_id
	},
		"GET", {
		isLoading: true,
		loadingText: '加载中...'
	}
	);
//展品详情接口
const detail_exhibition_info = (exhibit_id, language) =>
	axios(
		"/exhibit/exhibit_info", {
		p: PLAT,
		exhibit_id,
		language
	},
		"GET", {
		isLoading: true,
		loadingText: '加载中...'
	}
	);
//展品评论列表
const get_comment_list = (data) =>
	axios(
		"/exhibit/comment_list", {
		p: PLAT,
		exhibit_id: data.exhibit_id,
		page: data.page,
		limit: data.limit
	},
		"GET", {
		isLoading: true,
		loadingText: '加载中...'
	}
	);
//查询
const get_search = (key_words) =>
	axios(
		"/home_search", {
		p: PLAT,
		museum_id: MID,
		key_words
	},
		"GET", {
		isLoading: true,
		loadingText: '加载中...'
	}
	);



export default {
	exhibition_list,
	exhibits_list,
	exhibits_info,
	detail_exhibition_info,
	get_comment_list,
	get_search
};


// WEBPACK FOOTER //
// ./src/http/modules/exhibition.js